import { useQuery } from '@tanstack/react-query';

import { fetchCatalog } from '@/services/collections';

import { CATALOG_QUERY_KEY } from './useCollections';

/**
 * Открыто ли создание портретов. Тот же запрос и кэш, что у каталога:
 * отдельного обращения к серверу нет. Пока ответа нет — открыто, чтобы
 * экран не мигал «Скоро»; отказ всё равно даст сервер.
 */
export function useGenerationOpen(): boolean {
  const { data } = useQuery({
    queryKey: CATALOG_QUERY_KEY,
    queryFn: fetchCatalog,
    staleTime: 5 * 60_000,
    select: (catalog) => catalog.generationOpen,
  });

  return data ?? true;
}
